class SilentCartUpdater {
  constructor() {
    this.initialized = false;
    this.initEventListeners();
  }

  initEventListeners() {
    // Use capture phase to intercept events before they reach the default handlers
    document.addEventListener('click', this.handleClick.bind(this), true);
    
    // Additionally, intercept direct input changes
    document.addEventListener('change', (event) => {
      const quantityInput = event.target.closest('.quantity-input');
      if (!quantityInput || !quantityInput.closest('.cart-drawer')) return;
      
      // Prevent default form submission
      event.preventDefault();
      event.stopImmediatePropagation();
      
      const newValue = parseInt(quantityInput.value);
      if (isNaN(newValue) || newValue < 1) return;
      
      this.updateCartItem(quantityInput.dataset.quantityVariantId, newValue, quantityInput);
    }, true);
    
    // Add event listener for upsell product buttons
    document.addEventListener('click', (event) => {
      const upsellButton = event.target.closest('.cart-upsell-add-button');
      if (!upsellButton) return;
      
      const variantId = parseInt(upsellButton.dataset.variantId);
      const productId = parseInt(upsellButton.dataset.productId);
      
      this.addUpsellToCart(variantId, productId);
    });
    
    // Mark as fully initialized after a short delay to ensure this runs after Shopify's handlers
    setTimeout(() => {
      this.initialized = true;
    }, 500);
  }
  
  handleClick(event) {
    if (!event.target.closest('.cart-drawer')) return;
    
    const quantityButton = event.target.closest('.quantity-button');
    if (!quantityButton) return;
    
    // Always stop propagation in capture phase to prevent default handlers
    event.stopPropagation();
    event.preventDefault();
    
    const quantityInput = quantityButton.closest('quantity-input').querySelector('.quantity-input');

    if (!quantityInput) return;
    
    const currentValue = parseInt(quantityInput.value);
    const isPlus = quantityButton.name === 'plus';
    const newValue = isPlus ? currentValue + 1 : Math.max(1, currentValue - 1);
    
    // Update the visual display immediately
    quantityInput.value = newValue;
    
    // Perform silent update
    this.updateCartItem(quantityInput.dataset.quantityVariantId, newValue, quantityInput);
  }
  
  async updateCartItem(variantId, quantity, inputElement) {
    if (!variantId) return;
    
    // Find the cart item container
    const cartItemRow = inputElement.closest('.cart-item');
    if (!cartItemRow) return;
    
    // Show loading state
    const loadingOverlay = cartItemRow.querySelector('.loading-overlay');
    if (loadingOverlay) loadingOverlay.classList.remove('hidden');
    
    try {
      window.startCartSpinner()
      // Get current cart to find the line item key
      // const cartResponse = await fetch('/cart.js');
      // const cart = await cartResponse.json();
      
      // Find the item in the cart by variant ID
      // const cartItem = cart.items.find(item => item.variant_id === parseInt(variantId));
      // if (!cartItem) return;
      
      // Use line item key for the update
      const lineItemKey = inputElement.dataset.quantityVariantId
      const lineNumber = inputElement.dataset.index
     
      // Send the update request
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          // id: lineItemKey,
          line:(lineNumber)?.toString(),
          quantity: quantity?.toString(),
          sections: ["cart-drawer", "cart-icon-bubble","product-showcase-with-progress"]
        })
      });
      
      const updatedCart = await response.json();
      
      // Update the cart drawer with the response
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.cart.renderContents(updatedCart);
      
      // Trigger cart update event
      // document.dispatchEvent(new CustomEvent('cart:silentupdate', { 
      //   detail: { cart: updatedCart }
      // }));
    } catch (error) {
      console.error('Error updating cart:', error);
      // Show error message if needed
    } finally {
      // Hide loading state
      if (loadingOverlay) loadingOverlay.classList.add('hidden');
    }
  }
  
  async updateCartUI(cart) {
    // if (!cart) return;
    
    // // Simple AJAX refresh of the drawer inner content
    // fetch('/cart?view=drawer')
    //   .then(response => response.text())
    //   .then(html => {
    //     const parser = new DOMParser();
    //     const newCartDocument = parser.parseFromString(html, 'text/html');
        
    //     // Replace the drawer inner content
    //     const drawerInner = document.querySelector('.drawer-inner');
    //     const newDrawerInner = newCartDocument.querySelector('.drawer-inner');
        
    //     if (drawerInner && newDrawerInner) {
    //       drawerInner.innerHTML = newDrawerInner.innerHTML;
          
    //       // Find cart-drawer-items component to reattach all events
    //       const cartDrawerItems = document.querySelector('cart-drawer-items');
    //       if (cartDrawerItems) {
    //         // 1. Re-attach event listeners for close buttons
    //         const closeButtons = drawerInner.querySelectorAll('.drawer-close');
    //         closeButtons.forEach(button => {
    //           button.addEventListener('click', function() {
    //             this.closest('cart-drawer').close();
    //           });
    //         });
            
    //         // 2-5. Reattach all other event listeners by using CartDrawerItems methods
    //         if (typeof cartDrawerItems.reattachQuantityListeners === 'function') {
    //           cartDrawerItems.reattachQuantityListeners(drawerInner);
    //           cartDrawerItems.reattachRemoveButtonListeners(drawerInner);
    //           cartDrawerItems.reattachTermsCheckbox(drawerInner);
    //           cartDrawerItems.reattachCollapsibleSections(drawerInner);
    //         }
    //       }
          
    //       // Re-attach upsell product event listeners
    //       this.reattachUpsellEventListeners(drawerInner);
          
    //       // 6. Force update of the discount tier progress
    //       if (typeof updateDiscountTierProgress === 'function') {
    //         setTimeout(() => {
    //           updateDiscountTierProgress(cart.total_price);
    //         }, 100);
    //       }
    //     }
        
    //     // Notify that cart was updated
    //     document.dispatchEvent(new CustomEvent('cart:updated', { 
    //       detail: { cart: cart }
    //     }));
    //   })
    //   .catch(error => {
    //     console.error('Error refreshing cart drawer:', error);
    //   });
  }
  
  formatMoney(cents, withCurrency = false) {
    const currencySymbol = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'USD';
    const amount = (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: currencySymbol
    });
    
    return amount;
  }
  
  async addUpsellToCart(variantId, productId) {
    if (!variantId) return;
    
    // Find and show loading state on the button
    const addButton = document.querySelector(`.cart-upsell-add-button[data-variant-id="${variantId}"]`);
    if (addButton) {
      addButton.classList.add('loading');
      addButton.setAttribute('disabled', 'disabled');
      addButton.innerHTML = '<div class="loading-spinner"></div>';
    }
    
    window.startCartSpinner()
    
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            _upsell: true
          },
          sections: ["cart-drawer", "cart-icon-bubble","product-showcase-with-progress"]
        })
      }).then((response) => response.json()).then(response => {
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        setTimeout(() => { this.cart.renderContents({
          ...response?.items?.[0]||{},
          sections:response?.sections
        }) });
      });
  }

  async removeCartItem(lineId, buttonElement) {
    if (!lineId) return;
    
    // Find the cart item row
    const cartItemRow = buttonElement?.closest('tr.cart-item');
    
    // Show loading state
    if (cartItemRow) {
      const loadingOverlay = cartItemRow.querySelector('.loading-overlay');
      if (loadingOverlay) loadingOverlay.classList.remove('hidden');
    }
    
    if (buttonElement) {
      buttonElement.classList.add('loading');
      buttonElement.setAttribute('disabled', 'disabled');
    }
    
    try {
      // Get current cart to find the item key
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      let itemToRemove = null;
      if (!isNaN(parseInt(lineId))) {
        const lineIndex = parseInt(lineId) - 1;
        if (lineIndex >= 0 && lineIndex < cart.items.length) {
          itemToRemove = cart.items[lineIndex];
        }
      } else {
        itemToRemove = cart.items.find(item => item.key === lineId);
      }

      if (!itemToRemove) {
        console.error('Could not find item to remove');
        return;
      }

      const updates = {};
      updates[itemToRemove.key] = 0;

      const bundleId = itemToRemove.properties?._bundle;
      const isPaidItem = itemToRemove.final_price > 0 && !itemToRemove.properties?._free_gift && !itemToRemove.properties?._free_product;

      if (bundleId && isPaidItem) {
        cart.items.forEach(item => {
          if (item.key !== itemToRemove.key && item.properties?._bundle === bundleId && (item.properties?._free_gift === 'true' || item.properties?._free_product === 'true')) {
            updates[item.key] = 0;
          }
        });
      }
      
      window.startCartSpinner()
      // Remove the item(s) using a bulk update
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: updates,
          sections: ["cart-drawer", "cart-icon-bubble","product-showcase-with-progress"]
        })
      }).then((response) => response.json()).then(response => {
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        setTimeout(() => { this.cart.renderContents(response) });
      });
      
    } catch (error) {
      console.error('Error removing item from cart:', error);
      
      // Show error message
      const errors = document.getElementById('cart-errors') || 
                    document.getElementById('CartDrawer-CartErrors');
      if (errors) {
        errors.textContent = 'Error removing item. Please try again.';
      }
    } finally {
      // Reset loading states
      if (cartItemRow) {
        const loadingOverlay = cartItemRow.querySelector('.loading-overlay');
        if (loadingOverlay) loadingOverlay.classList.add('hidden');
      }
      
      if (buttonElement) {
        buttonElement.classList.remove('loading');
        buttonElement.removeAttribute('disabled');
      }
    }
  }

  // Add a separate method to refresh the cart drawer using the section rendering API
  async refreshCartDrawer() {
    try {
      // Fetch the cart-drawer section HTML
      const response = await fetch('/cart?view=drawer');
      const html = await response.text();
      
      // Parse the HTML
      const parser = new DOMParser();
      const newCartDocument = parser.parseFromString(html, 'text/html');
      
      // Replace the drawer inner content
      const drawerInner = document.querySelector('.drawer-inner');
      const newDrawerInner = newCartDocument.querySelector('.drawer-inner');
      
      if (drawerInner && newDrawerInner) {
        drawerInner.innerHTML = newDrawerInner.innerHTML;
        
        // Re-attach event listeners for close buttons
        const closeButtons = drawerInner.querySelectorAll('.drawer-close');
        closeButtons.forEach(button => {
          button.addEventListener('click', function() {
            this.closest('cart-drawer').close();
          });
        });
        
        // Re-attach event listeners for quantity buttons
        this.reattachEventListeners(drawerInner);
        
        // Re-attach upsell product event listeners
        this.reattachUpsellEventListeners(drawerInner);
        
        // Update discount tier progress
        if (typeof updateDiscountTierProgress === 'function') {
          setTimeout(() => {
            updateDiscountTierProgress();
          }, 100);
        }
      }
      
      return true;
    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
      return false;
    }
  }

  // Helper method to reattach event listeners
  reattachEventListeners(container) {
    // Reattach quantity input functionality
    const quantityInputs = container.querySelectorAll('quantity-input');
    quantityInputs.forEach(quantityInput => {
      const minusButton = quantityInput.querySelector('[name="minus"]');
      const plusButton = quantityInput.querySelector('[name="plus"]');
      const input = quantityInput.querySelector('.quantity-input');
      
      if (minusButton && input) {
        minusButton.addEventListener('click', () => {
          const currentValue = parseInt(input.value);
          if (currentValue > 1) {
            input.value = currentValue - 1;
            const event = new Event('change', { bubbles: true });
            input.dispatchEvent(event);
          }
        });
      }
      
      if (plusButton && input) {
        plusButton.addEventListener('click', () => {
          const currentValue = parseInt(input.value);
          input.value = currentValue + 1;
          const event = new Event('change', { bubbles: true });
          input.dispatchEvent(event);
        });
      }
    });
    
    // Reattach remove button functionality
    const removeButtons = container.querySelectorAll('cart-remove-button');
    removeButtons.forEach(button => {
      const actualButton = button.querySelector('button');
      if (actualButton) {
        button.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.removeCartItem(actualButton.dataset.lineId, actualButton);
        });
      }
    });
  }

  // Add a new method to reattach upsell event listeners
  reattachUpsellEventListeners(container) {
    // 1. Handle metaobject upsell products (from cart-upsell-products.liquid)
    const addButtons = container.querySelectorAll('.add-to-cart-button');
    addButtons.forEach(button => {
      button.addEventListener('click', () => {
        const variantId = button.getAttribute('data-variant-id');
        if (!variantId) return;
        
        // Add loading state
        button.classList.add('loading');
        
        // Use silentCartUpdater to add the product (if available)
        if (window.silentCartUpdater) {
          window.silentCartUpdater.addUpsellToCart(variantId, button.getAttribute('data-product-id'));
        } else {
          window.startCartSpinner()
          // Fallback to direct fetch if silentCartUpdater is not available
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
              properties: {
                _upsell: true
              }
            })
          })
          .then(response => response.json())
          .then(data => {
            // Refresh the cart
            this.refreshCartDrawer();
            
            // Remove loading state
            button.classList.remove('loading');
          })
          .catch(error => {
            console.error('Error:', error);
            button.classList.remove('loading');
          });
        }
      });
    });
    
    // 2. Handle cart-drawer upsell products
    const cartUpsellButtons = container.querySelectorAll('.cart-upsell-add-button');
    cartUpsellButtons.forEach(button => {
      button.addEventListener('click', () => {
        const variantId = parseInt(button.dataset.variantId);
        const productId = parseInt(button.dataset.productId);
        
        if (window.silentCartUpdater) {
          window.silentCartUpdater.addUpsellToCart(variantId, productId);
        }
      });
    });
  }
}

// Initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
  window.silentCartUpdater = new SilentCartUpdater();
});

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.cartItems=[]
    document.addEventListener('cart:updatedData', (event) => {
      this.updateCartData(event?.detail?.cart)
      // this.cartItems = event.detail.cart.items
    })
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );

     // const innner = this.querySelector(".drawer-inner")
    // window.addEventListener("resize", () => {
    //   const innner = this.querySelector(".drawer-inner")
    //   if(innner){
    //     innner.style.height= window.innerHeight+"px"
    //   }
    // })
    // if(innner){
    //   innner.style.height= window.innerHeight+"px"
    // }
    this.setHeaderCartIconAccessibility();
    // this.renderUpsellProducts()
    this.firstRender = false
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    cartLink.addEventListener("click", (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener("keydown", (event) => {
      if (event.code.toUpperCase() === "SPACE") {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  async removeFreeGift(cartItems){
    const freeGifts = cartItems?.filter(item => 
      item.handle?.includes("mystery-gift") && item?.final_line_price !== 0
    )

    if(freeGifts?.length > 0){
      // window?.cartSpinner?.start()
      
      // Create an object with all free gift keys set to quantity 0
      const updates = {}
      freeGifts.forEach(freeGift => {
        if(freeGift?.id){
          updates[freeGift.id] = 0
        }
      })

   
      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: updates,
            sections: ["cart-drawer", "cart-icon-bubble","product-showcase-with-progress"]
          })
        }).then(response => response.json()).then(response => {
          this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          setTimeout(() => { this.renderContents({
            ...response
          }) });
        })
      } catch(error) {
        window?.cartSpinner?.end()
        console.error('Error removing free gifts:', error);
      }
    }
  }

  updateCartData(cart){

   
   
   if(cart?.items){
        this.cartItems = cart.items
      }else{
        let found = false
        this.cartItems = this.cartItems?.map(item => {
          if(cart.variant_id===item?.variant_id){
            found = true
            return {
              ...cart
            } 
          }
          return item
         
        })
        if(!found){
          this.cartItems.push(cart)
        }
      }

  
      if(!this.firstRender && this.cartItems.length>0){
        this.renderUpsellProducts()
        this.firstRender = true
      }


      window.cartItems = this.cartItems

      this.removeFreeGift(this.cartItems)

  }

  open(triggeredBy) {
     if (window.setCartDrawerHeight) {
      window.setCartDrawerHeight();
    }
    const isCartPage = document.querySelector("cart-items");

    if (isCartPage) return;

    if (triggeredBy) this.setActiveElement(triggeredBy);

    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {

       
        const containerToTrapFocusOn =this.querySelector(".drawer-inner-empty")
          ? this.querySelector(".drawer-inner-empty")
          : document.querySelector("#CartDrawer");

        const focusElement =
          this.querySelector(".drawer-inner") ||
          this.querySelector(".drawer-close");

        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add("cart-drawer-quick-view");
   if (window.matchMedia("(min-width: 768px)").matches) {

    document.body.style.padding = "0 4px 0 0";
   
   }

    // const isMobile = window.innerWidth <= 768;
    //   if(isMobile){
    //      document.body.style.overflow = "hidden";
    // }
     document.body.style.overflow = "hidden";
    

    const animatedElements = this.querySelectorAll("[data-aos]");
    animatedElements.forEach((element) => {
      element.classList.add("aos-animate");
    });

    // Ensure bundle grouping is applied whenever the drawer is opened,
    // including the very first time after a page load (before any cart
    // AJAX has occurred).
    if (typeof this.groupBundleItems === 'function') {
      this.groupBundleItems();
    }
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("cart-drawer-quick-view");
    // if (window.innerWidth < 768) {
    document.body.style.overflow = "scroll";
    document.body.style.padding = "0";
    document.body.style.overflowX = "hidden";
       document.body.style.overflow = "";
    // }

    // const isMobile = window.innerWidth <= 768;
    //   if(isMobile){
    //      document.body.style.overflow = "";
    // }

    document.body.style.overflow = "";

    const animatedElements = this.querySelectorAll(".aos-animate");
    animatedElements.forEach((element) => {
      element.classList.remove("aos-animate");
    });
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderUpsellProducts(){

    const upsellProductIds = document.querySelector(".upsell-products-container")?.dataset?.upsellProductIds

   let productIds = []
   if(upsellProductIds){
    productIds = upsellProductIds.split(",")
   }

    const getUpsellProducts = document.querySelectorAll(".upsell-product-card")
    getUpsellProducts.forEach(product => {
      let discount =[]
      if(product.dataset.discount){
        discount = JSON.parse(product.dataset.discount)
      }
      const comparePrice = parseFloat(product.dataset.comparePrice)/100
      let price = parseFloat(product.dataset.price)/100
      const originalPrice = price // Store original price
      const variantId = product.dataset.variantId
      const currencyFormat = product.dataset.currencyFormat
      const productHandle = product.dataset.productHandle
      let currentQuantity = 1
      let displayPercentage = 0

      function formatCurrency(amount, currency,currencyFormat) {
        const options = { style: 'currency', currency: currency };
        return new Intl.NumberFormat('en-US', options).format(amount);
      }
      const rate = parseFloat(Shopify.currency.rate);

      const item = this.cartItems.find(item => productIds.includes(item.variant_id?.toString()))

      if(item){
        currentQuantity = this.cartItems.reduce((acc, item) => productIds.includes(item.variant_id?.toString()) ? acc + item.quantity : acc, 0) + 1
       
        let found = false
        discount.sort((a, b) => b.quantity?.toString() - a.quantity?.toString())

        for (let k = 0; k < discount.length; k++) {
          const item_discount = discount[k];
        
          if(item_discount.quantity <= currentQuantity){
            
            // Priority 1: Check for discount_perc first
            if (item_discount.discount_perc && item_discount.discount_perc > 0) {
              // Apply percentage discount to original price instead of compare price
              const discountAmount = originalPrice * (item_discount.discount_perc / 100);
              price = originalPrice - discountAmount;
              displayPercentage = item_discount.discount_percentage || item_discount.discount_perc;
            }
            // Priority 2: Fall back to discount_amount
            else if (item_discount.discount_amount && item_discount.discount_amount > 0) {
              // Apply fixed amount discount to original price
              const discountAmount = item_discount.discount_amount * rate;
              price = originalPrice - discountAmount;
              displayPercentage = item_discount.discount_percentage || Math.round((discountAmount / originalPrice) * 100);
            }
            // Priority 3: Legacy discount_percentage
            else if (item_discount.discount_percentage && item_discount.discount_percentage > 0) {
              // Apply percentage discount to original price instead of compare price
              const discountAmount = originalPrice * (item_discount.discount_percentage / 100);
              price = originalPrice - discountAmount;
              displayPercentage = item_discount.discount_percentage;
            }
            
            found = true;
            break;
          }
        } 
       
        if(!found && discount.length > 0){
          // Apply highest tier discount
          const highestDiscount = discount[discount.length-1];
          
          // Priority 1: Check for discount_perc first
          if (highestDiscount.discount_perc && highestDiscount.discount_perc > 0) {
            // Apply percentage discount to original price instead of compare price
            const discountAmount = originalPrice * (highestDiscount.discount_perc / 100);
            price = originalPrice - discountAmount;
            displayPercentage = highestDiscount.discount_percentage || highestDiscount.discount_perc;
          }
          // Priority 2: Fall back to discount_amount
          else if (highestDiscount.discount_amount && highestDiscount.discount_amount > 0) {
            const discountAmount = highestDiscount.discount_amount * rate;
            price = originalPrice - discountAmount;
            displayPercentage = highestDiscount.discount_percentage || Math.round((discountAmount / originalPrice) * 100);
          }
          // Priority 3: Legacy discount_percentage
          else if (highestDiscount.discount_percentage && highestDiscount.discount_percentage > 0) {
            // Apply percentage discount to original price instead of compare price
            const discountAmount = originalPrice * (highestDiscount.discount_percentage / 100);
            price = originalPrice - discountAmount;
            displayPercentage = highestDiscount.discount_percentage;
          }
        }
      } else {
        // Calculate standard discount for non-cart items
        if (comparePrice > originalPrice) {
          displayPercentage = Math.round((comparePrice - originalPrice) / comparePrice * 100);
        }
      }

      let price_sale = product.querySelector(".price-sale");
      let price_compare = product.querySelector(".price-compare");
      let sale_percentage = product.querySelector(".upsell-discount-badge")

      if(price_sale){
        price_sale.innerHTML = formatCurrency(price, Shopify.currency.active)
      }
      
      if(price_compare){
        price_compare.innerHTML = formatCurrency(comparePrice, Shopify.currency.active)
      }
      
      if(sale_percentage && displayPercentage > 0){
        let discount_badge = sale_percentage.dataset.discountBedge
        sale_percentage.innerHTML = discount_badge.replace("*discount_percentage*", displayPercentage)
        sale_percentage.style.display = 'inline-block';
      } else if(sale_percentage) {
        sale_percentage.style.display = 'none';
      }
    })
  }


   addShippingOption = (cartItems)=>{
    const shippingOption = cartItems?.find(item => item.handle?.includes("shipping-option"))
    if(shippingOption){
      return shippingOption
    }
    return null
  }
  
  async renderContents(parsedState,openDrawer=true) {
 
    const previousCartItems = this.cartItems;
    this.updateCartData(parsedState)
    this.querySelector(".drawer-inner").classList.contains("is-empty") &&
      this.querySelector(".drawer-inner").classList.remove("is-empty");
    this.productId = parsedState.id;
    
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

        if(sectionElement){
         sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
      }

      this.renderUpsellProducts()
    });

    /* -----------------------------------------------------------------
       Group items that belong to the same bundle (identified via the
       custom cart line-item property "_bundle") right after the
       freshly-rendered cart markup has been injected. This must be done
       AFTER the section HTML is swapped in, otherwise the DOM nodes we
       want to manipulate will not exist.
    ------------------------------------------------------------------*/
    this.groupBundleItems();

    // Add this to update discount tier progress
    if (window.updateDiscountTierProgress) {
      setTimeout(() => {
        window.updateDiscountTierProgress(parsedState.total_price);
      }, 100);
    }


     
    if(openDrawer){
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
    }

    // if(previousCartItems.length==0){
  // let timeout =  setTimeout(() => {
  //   if(window.handleInsuredShippingChange){
  //       window.handleInsuredShippingChange(true);
  //       clearTimeout(timeout)
  //   }
  //     }, 500);
  //   }

    document.dispatchEvent(new CustomEvent('cart:refreshed', { detail: parsedState }));

  }


  updateShippingOption(cartItems){
    const shippingOption = this.addShippingOption(cartItems)
    if(shippingOption){
      this.querySelector(".shipping-option").innerHTML = shippingOption
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: "#CartDrawer",
      },
      {
        id: "cart-icon-bubble",
      },
      {
        id: "product-showcase-with-progress",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // Add this new method to handle upsell product additions
  addToCart(button, variantId) {
    // Add loading state
    button.classList.add('loading');
    window.startCartSpinner();
    
    // Check if this variant already exists in this.cartItems
    const existingItem = this.cartItems.find(item => item.variant_id === parseInt(variantId));
  
    let fetchPromise;
    
    // if (existingItem) {
    //   // Item exists, update quantity
    //   fetchPromise = fetch('/cart/change.js', {
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json'
    //     },
    //     body: JSON.stringify({
    //       id: existingItem.key,
    //       quantity: existingItem.quantity + 1,
    //       sections: ["cart-drawer", "cart-icon-bubble","product-showcase-with-progress"]
    //     })
    //   });
    // } else {
      // Item doesn't exist, add it
      fetchPromise = fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: {
            _upsell: true
          },
          sections: ["cart-drawer", "cart-icon-bubble","product-showcase-with-progress"]
        })
      });
    // }
    
    fetchPromise
      .then(response => response.json())
      .then(data => {
        // Use this instance's renderContents method
        setTimeout(() => { this.renderContents({
          ...data?.items?.[0]||{},
          sections:data?.sections
        }) });
        
        // Remove loading state
        button.classList.remove('loading');
      })
      .catch(error => {
        console.error('Error:', error);
        button.classList.remove('loading');
      });
  }

  /* -------------------------------------------------------------------
     Bundle helpers – UI
  --------------------------------------------------------------------*/
  groupBundleItems() {
    // Bundle grouping has been disabled – no further action required.
    return;

    // 1. Unwrap previously created bundle groups so we can rebuild from
    //    scratch (simpler than trying to diff DOM between renders).
    this.querySelectorAll('.bundle-group').forEach(group => {
      const parent = group.parentNode;
      // Move children (header + items) except header back to parent.
      [...group.children].forEach(child => {
        if (!child.classList.contains('bundle-group-header')) {
          parent.insertBefore(child, group);
        }
      });
      group.remove();
    });

    // 2. Find all cart items that are part of a bundle (have data-bundle-id).
    const bundleItems = Array.from(this.querySelectorAll('.cart-item[data-bundle-id]'));
    if (!bundleItems.length) return;

    // 3. Group items by bundle id.
    const groups = {};
    bundleItems.forEach(item => {
      const bundleId = item.dataset.bundleId;
      if (!bundleId) return;

      if (!groups[bundleId]) {
        // Create wrapper element.
        const wrapper = document.createElement('div');
        wrapper.classList.add('bundle-group');
        wrapper.dataset.bundleId = bundleId;

        // Create simple header with remove button.
        const header = document.createElement('div');
        header.classList.add('bundle-group-header');
        header.innerHTML = `
          <div class=" cart-remove-button">
          <button type="button" class="bundle-remove-button button button--tertiary no-border" data-bundle-id="${bundleId}">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove">
  <path d="M6.5 1h3a.5.5 0 0 1 .5.5v1H6v-1a.5.5 0 0 1 .5-.5M11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3A1.5 1.5 0 0 0 5 1.5v1H1.5a.5.5 0 0 0 0 1h.538l.853 10.66A2 2 0 0 0 4.885 16h6.23a2 2 0 0 0 1.994-1.84l.853-10.66h.538a.5.5 0 0 0 0-1zm1.958 1-.846 10.58a1 1 0 0 1-.997.92h-6.23a1 1 0 0 1-.997-.92L3.042 3.5zm-7.487 1a.5.5 0 0 1 .528.47l.5 8.5a.5.5 0 0 1-.998.06L5 5.03a.5.5 0 0 1 .47-.53Zm5.058 0a.5.5 0 0 1 .47.53l-.5 8.5a.5.5 0 1 1-.998-.06l.5-8.5a.5.5 0 0 1 .528-.47M8 4.5a.5.5 0 0 1 .5.5v8.5a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5" fill="currentColor"></path>
</svg>
          </button></div>`;

        wrapper.appendChild(header);

        // Insert wrapper before the first item belonging to this bundle.
        item.parentNode.insertBefore(wrapper, item);

        // Store reference for subsequent items.
        groups[bundleId] = wrapper;
      }

      // Move item into its bundle wrapper.
      groups[bundleId].appendChild(item);
    });

    // 4. Attach event listeners to remove buttons.
    this.querySelectorAll('.bundle-remove-button').forEach(btn => {
      btn.addEventListener('click', () => {
        const bundleId = btn.dataset.bundleId;
        if (bundleId) {
          this.removeBundle(bundleId, btn);
        }
      });
    });
  }

  /* -------------------------------------------------------------------
     Bundle helpers – API interaction
  --------------------------------------------------------------------*/
  async removeBundle(bundleId, triggerButton = null) {
    if (!bundleId) return;

    try {
      if (triggerButton) {
        triggerButton.disabled = true;
        triggerButton.classList.add('loading');
      }

      // Show global cart spinner if available.
      if (window.startCartSpinner) window.startCartSpinner();

      // 1. Fetch current cart to obtain line item keys for this bundle.
      const cartResponse = await fetch('/cart.js');
      const cartData = await cartResponse.json();

      // 2. Build updates object to set quantity 0 for every item sharing bundleId.
      const updates = {};
      cartData.items.forEach(item => {
        if (item.properties && item.properties._bundle === bundleId) {
          updates[item.key] = 0;
        }
      });

      if (Object.keys(updates).length === 0) {
        // Nothing to remove.
        return;
      }

      // 3. Send bulk update.
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates,
          sections: [
            'cart-drawer',
            'cart-icon-bubble',
            'product-showcase-with-progress'
          ]
        })
      });

      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const updatedState = await response.json();

      // 4. Re-render cart with updated state. We intentionally do not open
      //    the drawer here since it is already open.
      this.renderContents(updatedState, false);

    } catch (error) {
      console.error('Error removing bundle:', error);
    } finally {
      if (triggerButton) {
        triggerButton.classList.remove('loading');
        triggerButton.disabled = false;
      }
    }
  }
}

customElements.define("cart-drawer", CartDrawer);

// Expose the CartDrawer addToCart method globally
window.CartUpsell = window.CartUpsell || {};
window.CartUpsell.addToCart = function(button, variantId) {
  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    cartDrawer.addToCart(button, variantId);
  }
};


